module.exports = {"missingPermission":"Du har desværre ikke de fornødne rettigheder til at tilgå denne side.","contactAdministration":"Kontakt den medarbejder, der er administrator for denne Trustpilot-konto."}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/MissingPermission/localization/da-DK/strings.json
// module id = 1226
// module chunks = 0